import { render, staticRenderFns } from "./LocalVideoItem.vue?vue&type=template&id=23b5c87b&scoped=true&"
import script from "./LocalVideoItem.vue?vue&type=script&lang=js&"
export * from "./LocalVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./LocalVideoItem.vue?vue&type=style&index=0&id=23b5c87b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5c87b",
  null
  
)

export default component.exports